export default {
  styleOverrides: {
    root: {
      "&$focused": {
        color: "#40354e",
      },
    },
  },
};
